import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconDolbyAtmos2_24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="Dolby Atmos">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 20V4H3C7.41828 4 11 7.58172 11 12C11 16.4183 7.41828 20 3 20H0ZM3 6C6.31371 6 9 8.68629 9 12C9 15.3137 6.31371 18 3 18H2V6H3Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24 20V4H21C16.5817 4 13 7.58172 13 12C13 16.4183 16.5817 20 21 20H24ZM21 6C17.6863 6 15 8.68629 15 12C15 15.3137 17.6863 18 21 18H22V6H21Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconDolbyAtmos48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="Dolby Atmos">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11 14H6V34H11C16.5228 34 21 29.5228 21 24C21 18.4772 16.5228 14 11 14ZM4 12V36H11C17.6274 36 23 30.6274 23 24C23 17.3726 17.6274 12 11 12H4Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M37 14H42V34H37C31.4772 34 27 29.5228 27 24C27 18.4772 31.4772 14 37 14ZM44 12V36H37C30.3726 36 25 30.6274 25 24C25 17.3726 30.3726 12 37 12H44Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M46 10H2V38H46V10ZM0 8V40H48V8H0Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
